import React from "react"
import PropTypes from "prop-types"

/** Tarjeta compacta de la fila inferior: cifra, apunte a la derecha y extras. */
const MiniKpiCard = ({ label, valor, unidad, aside, tono, children }) => (
  <div className="res-mini">
    <div className="res-mini-label">{label}</div>
    <div className={`res-mini-value${tono === "bad" ? " is-bad" : ""}`}>
      <span>{valor}</span>
      {unidad && <span className="res-mini-unit">{unidad}</span>}
      {aside && <span className="res-mini-aside">{aside}</span>}
    </div>
    {children}
  </div>
)

MiniKpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  valor: PropTypes.any,
  unidad: PropTypes.string,
  aside: PropTypes.any,
  tono: PropTypes.oneOf(["bad"]),
  children: PropTypes.any,
}

export default MiniKpiCard
